import cn from 'classnames';
import type { JSX } from 'react';
import type React from 'react';
import type { ErrorType } from '../../model/types';

export interface Props {
    className?: string;
    id: string;
    label?: string | JSX.Element;
    error?: ErrorType;
}

export default function FormGroup({ className, label, error, children, id }: React.PropsWithChildren<Props>) {
    return (
        <div className={cn('form-group', className)}>
            {label && <label htmlFor={id}>{label}</label>}
            {children}
            <div id={`error_feedback_${id}`} className="error">
                {error && error.message}
            </div>
        </div>
    );
}
